module.exports = __webpack_public_path__ + "static/media/logo1@2x.609b7d16.png";